module.exports = __webpack_public_path__ + "static/media/network_2.a749d18e.ico";